<template>
  <AppSkeletonCardTable v-if="loading"></AppSkeletonCardTable>
  <Card v-else>
    <template v-slot:content>
      <div class="p-grid p-jc-between">
        <div class="p-col-12">
          <h5>Versões do sistema</h5>
        </div>
        <div class="p-col-12">
          <DataTable :value="versions" responsiveLayout="stack">
            <Column header="Versão" field="name">
              <template #body="props">
                <a
                  href="#"
                  v-if="props.data.description"
                  @click="versionDialog = props.data"
                  >{{ props.data.name }}</a
                >
                <span v-else>
                  {{ props.data.name }}
                </span>
              </template>
            </Column>
            <Column header="Data" field="date">
              <template #body="props">{{
                $formatDate(props.data.date) || '-'
              }}</template>
            </Column>
            <Column header="Descrição" field="title">
              <template #body="props">{{ props.data.title || '-' }}</template>
            </Column>
          </DataTable>
        </div>
      </div>
    </template>
  </Card>
  <VersionNotesDialog v-model:version="versionDialog"></VersionNotesDialog>
</template>

<script>
import { VersionApi } from '../../../services/api';
import VersionNotesDialog from './VersionNotesDialog.vue';

export default {
  name: 'VersionNotes',
  components: {
    VersionNotesDialog,
  },
  data() {
    return {
      versions: [],
      loading: false,
      versionDialog: null,
    };
  },
  async created() {
    try {
      this.loading = true;
      const versionResponse = await VersionApi.fetch();
      this.versions = versionResponse.results;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
div >>> .p-card-content {
  padding: 0 !important;
}
</style>
